<template>
  <!-- 修改返点费用弹窗 -->
  <el-dialog title="修改返点费用" :visible.sync="dialogVisible" width="600px" :close-on-click-modal="false" @close="handleClose">
    <!-- 修改表单 -->
    <el-form :model="formData" :rules="rules" ref="editForm" label-width="150px">
      <!-- 识别码（只读） -->
      <el-form-item label="识别码" prop="OIDNO">
        <el-input v-model="formData.OIDNO" disabled></el-input>
      </el-form-item>

      <!-- 客户名称（只读） -->
      <el-form-item label="客户名称" prop="compName">
        <el-input v-model="formData.compName" disabled></el-input>
      </el-form-item>

      <!-- 使用单位（只读） -->
      <el-form-item label="使用单位" prop="usingUnit">
        <el-input v-model="formData.usingUnit" disabled></el-input>
      </el-form-item>

      <!-- 应收款（只读） -->
      <el-form-item label="应收款" prop="receivable">
        <el-input v-model="formData.receivable" disabled>
          <template slot="append">元</template>
        </el-input>
      </el-form-item>

      <!-- 已收款（只读） -->
      <el-form-item label="已收款" prop="paidAmount">
        <el-input v-model="formData.paidAmount" disabled>
          <template slot="append">元</template>
        </el-input>
      </el-form-item>

      <!-- 返点方案（只读） -->
      <el-form-item label="返点方案" prop="rebateTypeStr">
        <el-input v-model="formData.rebateTypeStr" disabled></el-input>
      </el-form-item>

      <!-- 返点费用（可编辑，必填） -->
      <el-form-item label="返点费用" prop="rebateFee">
        <el-input v-model="formData.rebateFee" placeholder="请输入返点费用" @input="calculateTaxAndPayable">
          <template slot="append">元</template>
        </el-input>
      </el-form-item>

      <!-- 居间人承担税率（可编辑，必填） -->
      <el-form-item label="居间人承担税率" prop="brokerTaxRate">
        <el-input v-model="formData.brokerTaxRate" placeholder="请输入居间人承担税率" @input="calculateTaxAndPayable">
          <template slot="append">%</template>
        </el-input>
      </el-form-item>

      <!-- 居间人承担税额（自动计算） -->
      <el-form-item label="居间人承担税额" prop="brokerTaxAmount">
        <el-input v-model="formData.brokerTaxAmount" disabled>
          <template slot="append">元</template>
        </el-input>
      </el-form-item>

      <!-- 应付返点费用（自动计算） -->
      <el-form-item label="应付返点费用" prop="payableRebateFee">
        <el-input v-model="formData.payableRebateFee" disabled>
          <template slot="append">元</template>
        </el-input>
      </el-form-item>
    </el-form>

    <!-- 弹窗底部按钮 -->
    <div slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取消</el-button>
      <el-button type="primary" @click="handleSave" :loading="saveLoading">保存</el-button>
    </div>
  </el-dialog>
</template>

<script>
// 导入修改返点费用API
import { updateRebate } from '@/api/contract/contract'

export default {
  name: 'EditRebateDialog',
  data () {
    return {
      // 弹窗显示状态
      dialogVisible: false,
      // 保存按钮加载状态
      saveLoading: false,
      // 表单数据
      formData: {
        entrustNum: '',                // 委托编号
        OIDNO: '',                     // 识别码
        compName: '',                  // 客户名称
        usingUnit: '',                 // 使用单位
        receivable: '',                // 应收款
        paidAmount: '',                // 已收款
        rebateTypeStr: '',             // 返点方案名称
        rebateFee: '',                 // 返点费用（可编辑）
        brokerTaxRate: '',             // 居间人承担税率
        brokerTaxAmount: '',           // 居间人承担税额
        payableRebateFee: ''           // 应付返点费用
      },
      // 表单验证规则
      rules: {
        rebateFee: [
          { required: true, message: '请输入返点费用', trigger: 'blur' },
          { pattern: /^[0-9]+(\.[0-9]{1,2})?$/, message: '请输入正确的金额格式', trigger: 'blur' }
        ],
        brokerTaxRate: [
          { required: true, message: '请输入居间人承担税率', trigger: 'blur' },
          { pattern: /^[0-9]+(\.[0-9]{1,2})?$/, message: '请输入正确的税率格式', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    /**
     * 打开弹窗
     * @param {Object} row - 当前行数据
     */
    openDialog (row) {
      this.dialogVisible = true

      // 初始化表单数据
      this.formData.entrustNum = row.entrustNum
      this.formData.OIDNO = row.OIDNO
      this.formData.compName = row.compName
      this.formData.usingUnit = row.usingUnit
      this.formData.receivable = row.receivable
      this.formData.paidAmount = row.paidAmount
      this.formData.rebateTypeStr = row.rebateTypeStr || ''
      this.formData.rebateFee = row.rebateFee
      this.formData.brokerTaxRate = row.brokerTaxRate || 0 // 默认0%
      this.formData.brokerTaxAmount = row.brokerTaxAmount
      this.formData.payableRebateFee = row.payableRebateFee
    },

    /**
     * 计算居间人承担税额和应付返点费用
     * 当返点费用或居间人承担税率改变时触发
     * 计算逻辑：
     * 1. 居间人承担税额 = 返点费用 × 居间人承担税率 / 100
     * 2. 应付返点费用 = 返点费用 - 居间人承担税额
     */
    calculateTaxAndPayable () {
      const rebateFee = parseFloat(this.formData.rebateFee) || 0
      const taxRate = parseFloat(this.formData.brokerTaxRate) || 0

      // 计算居间人承担税额 = 返点费用 × 税率 / 100
      const taxAmount = (rebateFee * taxRate / 100).toFixed(2)
      this.formData.brokerTaxAmount = taxAmount

      // 计算应付返点费用 = 返点费用 - 居间人承担税额
      const payableRebateFee = (rebateFee - parseFloat(taxAmount)).toFixed(2)
      this.formData.payableRebateFee = payableRebateFee
    },

    /**
     * 保存修改
     */
    handleSave () {
      // 表单验证
      this.$refs.editForm.validate((valid) => {
        if (valid) {
          this.saveLoading = true

          // 获取当前时间
          const now = new Date()
          const updateTime = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')}`

          // 构建保存数据
          const saveData = {
            entrustNum: this.formData.entrustNum,
            rebateFee: parseFloat(this.formData.rebateFee),
            brokerTaxRate: parseFloat(this.formData.brokerTaxRate),
            brokerTaxAmount: parseFloat(this.formData.brokerTaxAmount),
            updateTime: updateTime
          }

          // 调用修改接口
          updateRebate(saveData).then(res => {
            this.saveLoading = false
            if (res.retCode === 'ok') {
              this.$message.success('修改成功')
              this.handleClose()
              // 通知父组件刷新列表
              this.$emit('refresh')
            } else {
              this.$message.error(res.retMsg || '修改失败')
            }
          }).catch(error => {
            this.saveLoading = false
            console.error('保存失败:', error)
            this.$message.error('保存失败')
          })
        } else {
          this.$message.warning('请填写完整信息')
          return false
        }
      })
    },

    /**
     * 关闭弹窗
     * 清除数据并恢复默认状态
     */
    handleClose () {
      this.dialogVisible = false
      // 重置表单
      this.$refs.editForm.resetFields()
      // 清空表单数据
      this.formData = {
        entrustNum: '',
        OIDNO: '',
        compName: '',
        usingUnit: '',
        receivable: '',
        paidAmount: '',
        rebateTypeStr: '',
        rebateFee: '',
        brokerTaxRate: '',
        brokerTaxAmount: '',
        payableRebateFee: ''
      }
    }
  }
}
</script>

<style scoped>
/* 弹窗底部按钮样式 */
.dialog-footer {
  text-align: right;
}
</style>
